import React from 'react'
import { Router, RouteComponentProps } from '@reach/router'
import Appbar from 'components/Appbar'
import EmployeeSearch from './Search'
import TableView from './TableView'
import useEmployees from './hooks/useEmployees'
import { Icon, ModalLayer, PageContent } from '@ui'
import LocationComponent from './LocationFilterNote'
import { useHRLocations } from '@ui/selects/HRLocationSelect'
import { useUser } from '@hooks'
import { get } from 'lodash'
import LocationFilterNote from './LocationFilterNote'
import { legacyMode } from 'App'

export default function EmployeeManagement({ navigate }: RouteComponentProps) {
  const employees = useEmployees()

  const locations = useHRLocations()
  const user = useUser()
  const preferredLocation = get(user, 'user.employee.preferredLocations', [])
  const locationFilterNote =
    !legacyMode &&
    (preferredLocation.length === 0 || locations.length === preferredLocation.length ? null : (
      <LocationFilterNote />
    ))

  return (
    <>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <Router primary={false} navigate={navigate}>
        <ModalLayer path="*" reload={employees.reload} />
      </Router>
      <Appbar title="Employees" locationFilterNote={locationFilterNote}>
        <EmployeeSearch
          navigate={navigate}
          queryTable={(query) => {
            employees.applyFilters({
              ...employees.filters,
              filters: {
                ...employees.filters.filters,
                query,
              },
            })
          }}
        />
      </Appbar>
      <PageContent>
        <TableView {...{ employees, navigate }} />
      </PageContent>
    </>
  )
}
